import { createFeatureSelector } from "@ngrx/store";
import {
    FeedState,
} from "./model";

export const FEED_FEATURE_KEY = "vadmin.health.engage.feed";

export const getFeedState = createFeatureSelector<FeedState>(FEED_FEATURE_KEY);
